import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'multiple-choice',
})

export default class MultipleChoice extends Vue {


    // ------------------------------------------------------------
    // Properties

    @Prop()
    private content: any;

    @Prop({default: false})
    private showCorrect!: boolean;


    private get userAnswer() {
        const content = this.content;
        let userAnser = content.userAnswer;
        if (this.showCorrect) {
            userAnser = this.baseQuestions.filter((item: any) => item.isCorrect);
        }
        return userAnser[0] ? userAnser[0].id : null;
    }

    private get question() {
        const question = this.content.resource;
        return question;
    }

    private get baseQuestions() {
        return this.question.answers;
    }
    // --------------------------------------------------------------
    // Hooks


    // -------------------------------------------------------------
    // Methods

}
